import React, { Component } from 'react';
import { Label } from '@fluentui/react';
import * as msg from './Helper/Const';

export class SystemMaintenence extends Component {

    render() {
        return (
            <div className="formColumnRight">
                <div>
                    <Label className="subtitle">{msg.SystemMaintenenceTitle}</Label>
                    <br />
                    <Label className="labelInfo">{msg.SystemMaintenenceMsg}</Label>
                 </div> 
            </div>
        );
    }
}